
<template>
  <div class="segment-list">
    <v-list>
      <template v-for="(activity, index) in activities">
        <activity-summary-list-item :item="activity" :key="index"/>
      </template>
    </v-list>
  </div>
</template>

<script>
import ActivitySummaryListItem from '@/ux/components/activities/ActivitySummaryListItem.vue';
export default {

  name: 'activity-summary-list',
  components: { ActivitySummaryListItem },
  props: {
    activities: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
  }),
  methods: {
  },
};
</script>

<style scoped>
</style>
